import { FC, SVGProps } from 'react'

export const DotsHorizontal: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.53087 10.5309C3.87078 10.191 4.33179 10 4.8125 10C5.29321 10 5.75422 10.191 6.09413 10.5309C6.43404 10.8708 6.625 11.3318 6.625 11.8125C6.625 12.2932 6.43404 12.7542 6.09413 13.0941C5.75422 13.434 5.29321 13.625 4.8125 13.625C4.33179 13.625 3.87078 13.434 3.53087 13.0941C3.19096 12.7542 3 12.2932 3 11.8125C3 11.3318 3.19096 10.8708 3.53087 10.5309ZM10.9684 10.5309C11.3083 10.191 11.7693 10 12.25 10C12.7307 10 13.1917 10.191 13.5316 10.5309C13.8715 10.8708 14.0625 11.3318 14.0625 11.8125C14.0625 12.2932 13.8715 12.7542 13.5316 13.0941C13.1917 13.434 12.7307 13.625 12.25 13.625C11.7693 13.625 11.3083 13.434 10.9684 13.0941C10.6285 12.7542 10.4375 12.2932 10.4375 11.8125C10.4375 11.3318 10.6285 10.8708 10.9684 10.5309ZM18.4059 10.5309C18.7458 10.191 19.2068 10 19.6875 10C20.1682 10 20.6292 10.191 20.9691 10.5309C21.309 10.8708 21.5 11.3318 21.5 11.8125C21.5 12.2932 21.309 12.7542 20.9691 13.0941C20.6292 13.434 20.1682 13.625 19.6875 13.625C19.2068 13.625 18.7458 13.434 18.4059 13.0941C18.066 12.7542 17.875 12.2932 17.875 11.8125C17.875 11.3318 18.066 10.8708 18.4059 10.5309Z"
			fill="currentColor"
		/>
	</svg>
)
